// IP Address Range Start for each system
export const SYSTEM_IP_RANGE_START = {
  charge_station: 56,
  big_plc_charge_station: 100,
  electric_heating: 66,
  heating_pump: 76,
};
